import { format, parse, } from 'date-fns';
import { afterMonths, beforeDays, getFormattedDate, } from '@/utils/time';
import { i18n } from '@/locales';
const getters = {
    // eslint-disable-next-line no-shadow
    getterSelectedHubName: (state, getters, rootState, rootGetters) => {
        // @ts-ignore
        const { hubs } = rootState.hubSelector;
        const getterSubscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
        if (!getterSubscribeHubId) {
            const hubName = rootGetters['user/hubName'];
            const hubId = rootGetters['user/hubId'];
            return `${hubName} ${hubId}`;
        }
        const hubList = Object.values(hubs);
        let subscribeHubName = '-';
        if (hubList.length > 0) {
            const filteredHubInfo = hubList.filter((list) => list.value.id === getterSubscribeHubId)[0];
            if (!filteredHubInfo) {
                return `테스트 모드: ${getterSubscribeHubId}`;
            }
            subscribeHubName = filteredHubInfo.text;
        }
        return `${subscribeHubName} ${getterSubscribeHubId}`;
    },
    getterSelectedHubInfo: ({ selectedHubInfo }) => {
        if (!selectedHubInfo) {
            return {};
        }
        const { validatedBusinessName, validatedBusinessNumber, validatedBusinessType, validatedBusinessCondition, validatedCeoName, validatedCeoEmail, formattedFullAddress, } = selectedHubInfo;
        return {
            businessName: validatedBusinessName,
            businessNumber: validatedBusinessNumber,
            businessType: validatedBusinessType,
            businessCondition: validatedBusinessCondition,
            ceoName: validatedCeoName,
            ceoEmail: validatedCeoEmail,
            formattedFullAddress,
        };
    },
    getterHeadOfficeInfo: ({ headOfficeInfo }) => headOfficeInfo,
    getterFormattedBusinessStatusType: ({ hubMainReport }) => hubMainReport?.formattedBusinessStatusType,
    getterFormattedTaxType: ({ hubMainReport }) => hubMainReport?.formattedTaxType,
    getterTaxInvoiceId: ({ hubMainReport }) => hubMainReport?.taxInvoiceId,
    // eslint-disable-next-line max-len
    getterIsSomeSalesOrderDistributorHubFeeAmountExist: ({ hubMainReport }) => hubMainReport?.isSomeSalesOrderDistributorHubFeeAmountExist,
    getterMainHubSalesReport: ({ hubMainReport, }) => {
        const lc = 'views.hub_adjustment.';
        if (!hubMainReport) {
            return [];
        }
        const { 
        // [매출 - 배달대행료 - B2B]
        formattedSalesB2BOrderCompletedCount, formattedSalesB2BDeliveryCharge, formattedSalesB2BDeliveryChargeTax, formattedSalesB2BDeliveryTotalCharge, isAllSalesB2BDeliveryChargeAmountExist, 
        // [매출 - 배달대행료 - 로드샵(본사계약)]
        formattedSalesHeadOfficeContractStoreOrderCompletedCount, formattedSalesHeadOfficeContractStoreDeliveryCharge, formattedSalesHeadOfficeContractStoreDeliveryChargeTax, formattedSalesHeadOfficeContractStoreDeliveryTotalCharge, isAllSalesHeadOfficeContractStoreDeliveryChargeAmountExist, 
        // [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)]
        formattedSalesOrderDistributorHubFeeOrderCompletedCount, formattedSalesOrderDistributorHubFee, formattedSalesOrderDistributorHubFeeTax, formattedSalesOrderDistributorHubTotalFee, isAllSalesOrderDistributorHubFeeAmountExist, 
        // [매출 - 기타 수수료]
        formattedSalesAdjustmentFeePayback, formattedSalesAdjustmentFeeTaxPayback, formattedSalesAdjustmentTotalFeePayback, 
        // [매출 - 상점 관리비 - 로드샵(본사계약)]
        formattedSalesHeadOfficeContractStoreManagementFee, formattedSalesHeadOfficeContractStoreManagementFeeTax, formattedSalesHeadOfficeContractStoreManagementTotalFee, isAllSalesHeadOfficeContractStoreManagementFeeAmountExist, 
        // [매출 - 상점 수수료 - 로드샵(본사계약)]
        formattedSalesHeadOfficeContractStoreFee, formattedSalesHeadOfficeContractStoreFeeTax, formattedSalesHeadOfficeContractStoreTotalFee, isAllSalesHeadOfficeContractStoreFeeAmountExist, 
        // [매출 - 보정 처리]
        formattedCorrectedCost, formattedCorrectedTax, formattedCorrectedTotalCost, formattedCorrectedReason, 
        // [매입 - 허브 수수료 - 로드샵(일반)]
        formattedSalesItemsTotalCount, formattedSalesItemsTotalFee, formattedSalesItemsTotalFeeTax, formattedSalesItemsTotalSum, } = hubMainReport;
        const result = [
            {
                name: {
                    title: 'b2b_delivery_charge',
                    chipInfo: {
                        color: 'blue',
                        text: i18n.t(`${lc}B2B`),
                    },
                },
                orderCount: formattedSalesB2BOrderCompletedCount,
                supplyValue: formattedSalesB2BDeliveryCharge,
                VAT: {
                    amount: formattedSalesB2BDeliveryChargeTax,
                },
                totalAmount: formattedSalesB2BDeliveryTotalCharge,
                isAllItemAmountExist: isAllSalesB2BDeliveryChargeAmountExist,
            },
            {
                name: {
                    title: 'road_shop_delivery_charge',
                    chipInfo: {
                        color: 'green',
                        text: i18n.t(`${lc}head_office_contract_store`),
                    },
                },
                orderCount: formattedSalesHeadOfficeContractStoreOrderCompletedCount,
                supplyValue: formattedSalesHeadOfficeContractStoreDeliveryCharge,
                VAT: {
                    amount: formattedSalesHeadOfficeContractStoreDeliveryChargeTax,
                },
                totalAmount: formattedSalesHeadOfficeContractStoreDeliveryTotalCharge,
                isAllItemAmountExist: isAllSalesHeadOfficeContractStoreDeliveryChargeAmountExist,
            },
            {
                name: {
                    title: 'sales_order_distributor_hub_fee',
                },
                orderCount: formattedSalesOrderDistributorHubFeeOrderCompletedCount,
                supplyValue: formattedSalesOrderDistributorHubFee,
                VAT: {
                    amount: formattedSalesOrderDistributorHubFeeTax,
                },
                totalAmount: formattedSalesOrderDistributorHubTotalFee,
                isAllItemAmountExist: isAllSalesOrderDistributorHubFeeAmountExist,
            },
            {
                name: {
                    title: 'sales_adjustment_fee_payback',
                },
                orderCount: '-',
                supplyValue: formattedSalesAdjustmentFeePayback,
                VAT: {
                    amount: formattedSalesAdjustmentFeeTaxPayback,
                },
                totalAmount: formattedSalesAdjustmentTotalFeePayback,
                tooltipText: i18n.t(`${lc}hub_adjustment_tooltip_content`),
            },
            {
                name: {
                    title: 'store_management_fee',
                    chipInfo: {
                        color: 'green',
                        text: i18n.t(`${lc}head_office_contract_store`),
                    },
                },
                orderCount: '-',
                supplyValue: formattedSalesHeadOfficeContractStoreManagementFee,
                VAT: {
                    amount: formattedSalesHeadOfficeContractStoreManagementFeeTax,
                },
                totalAmount: formattedSalesHeadOfficeContractStoreManagementTotalFee,
                isAllItemAmountExist: isAllSalesHeadOfficeContractStoreManagementFeeAmountExist,
            },
            {
                name: {
                    title: 'store_fee',
                    chipInfo: {
                        color: 'green',
                        text: i18n.t(`${lc}head_office_contract_store`),
                    },
                },
                orderCount: '-',
                supplyValue: formattedSalesHeadOfficeContractStoreFee,
                VAT: {
                    amount: formattedSalesHeadOfficeContractStoreFeeTax,
                },
                totalAmount: formattedSalesHeadOfficeContractStoreTotalFee,
                isAllItemAmountExist: isAllSalesHeadOfficeContractStoreFeeAmountExist,
            },
            {
                name: {
                    title: 'corrected_fee',
                },
                orderCount: '-',
                supplyValue: formattedCorrectedCost,
                VAT: {
                    amount: formattedCorrectedTax,
                },
                totalAmount: formattedCorrectedTotalCost,
                tooltipText: formattedCorrectedReason,
            },
            {
                name: {
                    title: 'total',
                },
                orderCount: formattedSalesItemsTotalCount,
                supplyValue: formattedSalesItemsTotalFee,
                VAT: {
                    amount: formattedSalesItemsTotalFeeTax,
                },
                totalAmount: formattedSalesItemsTotalSum,
            },
        ];
        return result;
    },
    getterMainHubPurchaseReport: ({ hubMainReport, }) => {
        const lc = 'views.hub_adjustment.';
        if (!hubMainReport) {
            return [];
        }
        const { 
        // [매입 - 허브 수수료 - 로드샵(일반)]
        formattedPurchaseHubFeeOrderCompletedCount, formattedPurchaseHubFee, formattedPurchaseHubFeeTax, formattedPurchaseHubTotalFee, isAllPurchaseHubFeeAmountExist, 
        // [매입 - 상점 관리비 - 로드샵(일반)]
        formattedPurchaseStoreManagementFee, formattedPurchaseStoreManagementTotalFee, formattedPurchaseStoreManagementFeeTax, isAllPurchaseStoreManagementAmountExist, formattedPurchaseItemsTotalCount, formattedPurchaseItemsTotalFee, formattedPurchaseItemsTotalFeeTax, formattedPurchaseItemsTotalSum, } = hubMainReport;
        return [
            {
                name: {
                    title: 'hub_fee',
                    chipInfo: {
                        color: 'blueGrey',
                        text: i18n.t(`${lc}head_office_not_contract_store`),
                    },
                },
                orderCount: formattedPurchaseHubFeeOrderCompletedCount,
                supplyValue: formattedPurchaseHubFee,
                VAT: {
                    amount: formattedPurchaseHubFeeTax,
                },
                totalAmount: formattedPurchaseHubTotalFee,
                isAllItemAmountExist: isAllPurchaseHubFeeAmountExist,
            },
            {
                name: {
                    title: 'store_management_fee',
                    chipInfo: {
                        color: 'blueGrey',
                        text: i18n.t(`${lc}head_office_not_contract_store`),
                    },
                },
                orderCount: '-',
                supplyValue: formattedPurchaseStoreManagementFee,
                VAT: {
                    amount: formattedPurchaseStoreManagementFeeTax,
                },
                totalAmount: formattedPurchaseStoreManagementTotalFee,
                isAllItemAmountExist: isAllPurchaseStoreManagementAmountExist,
            },
            {
                name: {
                    title: 'total',
                },
                orderCount: formattedPurchaseItemsTotalCount,
                supplyValue: formattedPurchaseItemsTotalFee,
                VAT: {
                    amount: formattedPurchaseItemsTotalFeeTax,
                },
                totalAmount: formattedPurchaseItemsTotalSum,
            },
        ];
    },
    getterSelectedMonth: ({ filterOption }) => filterOption.selectedMonth,
    getterSelectedMonthToFullDate: ({ filterOption }) => {
        if (!filterOption.selectedMonth) {
            return '';
        }
        const monthFormat = 'yyyy-MM';
        const dateObject = new Date();
        const selectedFullDate = parse(filterOption.selectedMonth, monthFormat, dateObject);
        const dateFormat = 'yyyyMMdd';
        const nextMonth = afterMonths(selectedFullDate, 1);
        return [
            selectedFullDate.setDate(1),
            beforeDays(nextMonth, 1),
        ].map((date) => format(date, dateFormat));
    },
    getterFileName: ({ filterOption, hubMainReport, }, 
    // eslint-disable-next-line no-shadow
    getters, rootState, rootGetters) => {
        let filename = '';
        if (hubMainReport === null) {
            return filename;
        }
        const date = getFormattedDate(filterOption.selectedMonth, 'yyyy-MM', 'yyyyMM');
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        if (!hubId || !date) {
            return filename;
        }
        filename = i18n.t('views.hub_adjustment.file_name', {
            hubId,
            date,
        });
        return filename;
    },
};
export default getters;
